"use strict";


import objectPath from "object-path";
import formatAddress from "../../account/utilities/formatAddress";

const orderAddress = (order, addressType ='billing') => {
    let keys = [];
    switch (addressType) {
        case "billing":
            keys = ['company_name', 'f_name', 'l_name', 'attention', 'b_address',
                    'b_address2', 'b_city', 'b_state', 'b_zip5', 'b_zip4',
                    'b_phone', 'b_phone_ext', 'b_fax', 'b_location_class',];
            break;
        case "shipping":
            keys = ['s_company', 's_f_name', 's_l_name', 's_attention', 's_address',
                    's_address2', 's_city', 's_state', 's_zip5', 's_zip4',
                    's_phone', 's_phone_ext', 's_fax', 's_location_class',];
            break;
    }
    let address = {};
    if(keys.length){
        keys.map((key)=>{
            address[key] = objectPath.get(order, key, '');
        })
    }
    return formatAddress(address);
}

export default orderAddress;